<template>
    <div>
        <v-dialog :value="model.active" width="40vw" persistent  >
            <!-- Modal content -->
            <v-card>
                <div class="d-flex justify-space-between align-center pr-2">
                    <v-card-title class="text-h6 font-weight-bold">
                        {{ isNewVersion ? 'Upload New Version' : 'Add Document Revision' }}
                    </v-card-title>
                    <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
                </div>
                <v-divider></v-divider>

           
                <v-card-text class="pt-5">
                    <v-row class="d-flex" style="height:50vh;">
                        <v-col cols="4" class="h-100">
                            <div v-if="isNewVersion" class="mb-3 text-body-2">
                                <div v-if="nextVersionNumber">Will be saved as <strong>v{{ nextVersionNumber }}</strong>.</div>
                                <v-alert v-if="parentDocument.isCurrentOverridden" dense outlined type="warning" class="mt-2 mb-0" style="font-size: 0.8rem">
                                    v{{ parentDocument.currentVersionNumber }} is pinned as current. The new version will not be shown by default until the pin is cleared.
                                </v-alert>
                            </div>
                            <div v-for="doc  in documents" :key="doc.id" >
                                <v-text-field outlined label="Revision Number" v-model="doc.revisionNumber" > </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="8" class="h-100 pb-5 d-flex justify-center  flex-column">
                         
                            <DocumentViewer :key="selected?.id" :item="selected" ref="documentViewer" class="h-100 w-100"></DocumentViewer>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" small elevation="0" :loading="model.loading" @click="submit"
                        :disabled="!documents&&documents.length==0 ">
                        Done
                    </v-btn>
                    <v-btn elevation="0" small :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red" small elevation="0" text @click="closeDialog"> close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <AddDocumentModal ref="uploadDocumentsModal"  @uploadCompleted="onUploadCompleted"/>
      
        <UpdateDocumentModal ref="updateDocumentModal"   @updateCompleted="onUpdateCompleted"/>
    </div>
</template>

<script>
    import AddDocumentModal from '@/components/attachments/add-document-modal.vue';
    import UpdateDocumentModal from '@/components/attachments/update-document-modal.vue';
    import headers from '../config/upload-documents-header';
    import DocumentViewer from './DocumentViewer.vue';
    import { log, warn, error } from '@/utils/debugLogger';
    import documentVersionsService from '@/features/Documents/service/documentVersions.service';
    import { linkCountLabel } from '@/features/Documents/utils/documentVersions';

export default {
data(){
    return {
        taskId:'',
        options:null,
        documents:[],
        selected:null,
        model:{
            active:false,
            valid:false,
            loading:false
        },
        headers
        

    }
},
computed:{
    isNewVersion(){
        return this.options?.type == 'add-revision';
    },
    parentDocument(){
        return this.options?.document || {};
    },
    /**
     * A hint only: the API assigns highest + 1. The current version is the highest unless
     * pinned; a pinned document's highest number is not on the list row, so no hint then.
     */
    nextVersionNumber(){
        const doc = this.parentDocument;
        return !doc.isCurrentOverridden && doc.currentVersionNumber ? doc.currentVersionNumber + 1 : null;
    },
},
created(){
},
methods:{
    /**
     * Links belong to one version. When the current version has links, asks whether to transfer
     * them to the new version. Resolves to true / false, or null when the user cancels.
     */
    async askTransferLinks(documentId){
        let linkCount = 0;
        let versionNumber = null;
        try {
            const result = await documentVersionsService.getLinkCount(documentId);
            linkCount = result?.linkCount || 0;
            versionNumber = result?.versionNumber ?? null;
        } catch (err) {
            // Without the count there is nothing to ask; the version is added without links.
            error('[AddDocumentRevision]', 'Could not count the links:', err);
        }
        if (linkCount === 0) return false;

        const answer = await this.$dialog.confirm({
            title: 'Transfer the links to the new version?',
            text: `${linkCountLabel(linkCount)} ${linkCount === 1 ? 'is' : 'are'} placed on ${versionNumber ? `v${versionNumber}` : 'the current version'}. `
                + 'Links belong to one version: transfer them, or start the new version without links. The earlier version keeps its links either way.',
            actions: {
                cancel: 'Cancel',
                skip: 'Without links',
                transfer: { text: 'Transfer links', color: 'primary' },
            },
        });
        if (answer === 'transfer') return true;
        if (answer === 'skip') return false;
        return null;
    },
    open(taskId,options=null){
        
        this.taskId=taskId;
        this.options=options;
        this.$refs.uploadDocumentsModal.open({singleFile:this.options?.singleFile||false});
    },
    closeDialog(){
        this.$refs.uploadDocumentsModal.closeDialog();
        this.model.active=false;
    },
    discard(){
        this.$refs.uploadDocumentsModal.closeDialog();
        this.model.active=false;
    },
    onUploadCompleted(result){
     
       let documents=structuredClone( result);
       if(this.options&&this.options.type=='add-revision'){
        documents.forEach(doc => {
        doc.taskId=this.taskId;
        doc.documentTitle=this.options.document.documentTitle,
        doc.documentNumber=this.options.document.documentNumber,
        doc.documentTypeId=this.options.document.documentTypeId,
        doc.revisionNumber=this.options.document.revisionNumber||'00'
        doc.forgeTagsIds=this.options.document.forgeTagsIds
       });
       }
       else{
        documents.forEach(doc => {
        doc.taskId=this.taskId;
        doc.documentTitle=doc.fileName,
        doc.documentNumber=doc.fileName,
        doc.revisionNumber='00'
        doc.forgeTagsIds=[]
       });
       
       }
   
        this.documents=documents;
        this.selected=this.documents[0];
        //this.openDocument(this.documents[0]);
        this.model.active=true;
        
    },
    onUpdateCompleted(item){
        //result
        this.documents[item.$index]=item;
        this.documents=this.documents.map(e=>e);
        delete item.$index;
    },
    submit(){
        // A second click while saving would upload the file twice.
        if (this.model.loading) return;
        var payLoad =structuredClone( this.documents);
        let request = null;
        if(this.options){
            switch (this.options.type) {
                case 'add-revision':
                    payLoad =structuredClone( this.documents[0]);
                     payLoad.documentId = this.options.document.id ;

                    request = this.askTransferLinks(payLoad.documentId).then((transferLinks) => {
                        // The prompt was cancelled: stay in this dialog.
                        if (transferLinks === null) return;
                        payLoad.transferLinks = transferLinks;
                        return this.$store.dispatch('TASK_DOCUMENT/ADD_REVISION', payLoad).then(() => {
                            this.closeDialog();
                        });
                    });
                    break;

                default:
                    break;
            }
        }
        else{
            request = this.$store.dispatch('TASK_DOCUMENT/ADD',payLoad).then((res)=>{
            if (!res?.cancelled) this.closeDialog();
        });
        }
        if (!request) return;
        this.model.loading = true;
        request
            // The store action has already shown the error.
            .catch(() => {})
            .finally(() => {
                this.model.loading = false;
            });
    },
    openDocument(item){
        log("🚀 ~ openDocument ~ item:", item)
        this.selected=item;
        
    },
    rowClicked(mouseEvent,ev){
        this.selected=ev.item;
    },
    rowDblClicked(mouseEvent,ev){
       
        this.editDocument(ev);
       
    },
    editDocument(){
        var clone=structuredClone(this.selected);
        clone.$index=this.documents.indexOf( this.selected);
        this.$refs.updateDocumentModal.open(clone);
    },
    deleteDocument(item){
        this.documents=this.documents.filter(e=>e!=item);
        if (this.documents.length)
            this.selected = this.documents[0];
        else
             this.selected=null;
    },
    tagDisplayName(id) {
        return this.forgeTags.find((t) => t.id == id)?.name ?? '';
      },
      getDocumentTypeDisplay(id) {
        return this.documentTypes.find((d) => d.id == id)?.name ?? '';
      },
},
    components: {
        AddDocumentModal,
        DocumentViewer,
        UpdateDocumentModal
    }
}
</script>

<style>
 
</style>